import { useGetAccessoiresInfo } from "components/EtudeForm/hooks/useGetAccessoriesInfo";
import { Text } from "components/shared/text";
import React, { useEffect, useState } from "react";
import { BasketSummary } from "./../BasketSummary";

import { useCurrentEtudeData } from "components/EtudeForm/hooks/useCurrentEtudeData";
import Loader from "components/shared/loader";
import Scroll from "components/shared/scroll";
import { EtudeDownload } from "./EtudeDownload";
import { EtudeInfoTable } from "./EtudeInfoTable";
import { EtudeProducts } from "./EtudeProducts";
import { NewStudy } from "./NewStudy";
import { useAppSelector } from "store/hooks";
import { useEtudeUpdate } from "components/EtudeForm/hooks/useEtudeUpdate";
export const SolutionDocuments: React.FC = () => {
  const authState = useAppSelector((state) => state.auth);
  const solutionsState = useAppSelector((state) => state.etude.solutions);
  const [allowOpenDocument, setAllowOpenDocument] = useState<boolean>(false)
  const {
    solution,
    installationType,
    service,
    etudeData,
    json,
    isLoading,
    hasEcs,
    selectedDetail
  } = useCurrentEtudeData();

  const {
    items,
    selectionInfo: {
      selectedAccessoiresNonSupp,
      selectedAccessoiresSupp,
      selectedBoilers,
      selectedServices,
    },
  } = useGetAccessoiresInfo(solution, installationType, json?.accessoires);

  const { navigateToAccessoires } = useEtudeUpdate();

  useEffect(() => {
    if (authState.profile.id !== etudeData?.collaborateurId && selectedDetail) {
      navigateToAccessoires(selectedDetail)
    } else if (authState.profile.id === etudeData?.collaborateurId) {
      setAllowOpenDocument(true)
    }
  }, [authState, etudeData, selectedDetail, navigateToAccessoires])
  return (
    <view data-scroll="">
      {(isLoading || !allowOpenDocument || !solutionsState || solutionsState.length === 0) && <Loader />}
      {solution && allowOpenDocument && (
        <>
          <group
            data-justify="space-between"
            data-direction="row"
            data-space="20"
            data-gap="40"
            data-max-length="1440"
            data-position="center"
            data-wrap="no"
          >
            <group data-direction="column" data-gap="50">
              <group
                data-width="autofit"
                data-align="center"
                data-height="30"
                data-gap="8"
              >
                <icon
                  data-background="success-color-light"
                  data-color="success-color"
                  data-border-color="success-color"
                  data-radius="30"
                  data-length="30"
                  data-height="30"
                >
                  done
                </icon>
                <Text
                  data-text-size="22"
                  data-color="grey-color-dark"
                  data-align="center"
                >
                  FO_DOC_RAPPORT_IS_READY
                </Text>
              </group>
              <group data-border="" data-radius="8" data-contain="">
                <group
                  data-align="center"
                  data-gap="5"
                  data-background="accent-xtralight"
                  data-space="10"
                  data-space-horizontal="20"
                  data-wrap="no"
                >
                  <Text
                    data-uppercase=""
                    data-weight="600"
                    data-ellipsis=""
                    data-color="grey-color-dark"
                  >
                    FO_DOC_SYNTHESIS
                  </Text>
                </group>
                <group
                  data-space-vertical="24"
                  data-space-horizontal="40"
                  data-gap="20"
                >
                  <EtudeInfoTable
                    solution={solution}
                    etudeData={etudeData!}
                    hasEcs={hasEcs!}
                    installationType={installationType}
                    json={json}
                    selectionInfo={{
                      selectedAccessoiresNonSupp,
                      selectedAccessoiresSupp,
                      selectedBoilers,
                      selectedServices,
                    }}
                    service={service!}
                  />
                  <EtudeDownload />
                </group>
                <group>
                  <Scroll>
                    <BasketSummary
                      {...items!}
                      selectedAccessoiresNonSupp={selectedAccessoiresNonSupp}
                      selectedAccessoiresSupp={selectedAccessoiresSupp}
                      selectedBoilers={selectedBoilers}
                      selectedServices={selectedServices}
                      solution={solution}
                    />
                  </Scroll>
                </group>
              </group>
              <EtudeProducts solution={solution!} />
            </group>
            <NewStudy />
          </group>
        </>
      )}
    </view>
  );
};
